// @flow
/* eslint pinterest/no-translation-outside-of-function:0 */
/* eslint prefer-numeric-literals:0 */
/* eslint no-bitwise:0 */

import BrowserType from 'app/packages/browser';
import templateConst from 'app/common/lib/templateConst';
/*
 * Note: some consts from this file have been moved to webapp/const/js.json
 * The consts in js.json are inlined into our source files and referenced
 * using PCONST.
 *
 * This gives us savings as we don't include the full list of constants in
 * every bundle, and saves bundle size since a lot of the values are much shorter
 * than the keys.
 */

const CONST = {};

CONST.GEN = {
  templateConst,
};

/**
 * Error strategies
 *
 * @enum {number}
 */
const ErrorStrategy = {
  SHOW: 0,
  BUBBLE: 1,
  REMOVE: 2,
};

/**
 * Position modes
 *
 * @enum {number}
 */
const PositionMode = {
  VIEWPORT_MIDDLE: 1,
  ANCHORED: 2,
  MANUAL: 3,
};

/**
 * Step types for user education guide
 *
 * @enum {string}
 */
const ViewActions = {
  OPEN: 'open',
  CLOSE: 'close',
};

/**
 * @enum {string}
 */
const BoardPrivacy = {
  SECRET: 'secret',
  PUBLIC: 'public',
  PROTECTED: 'protected',
};
// TODO(mwalker) this is already defined in packages/pinterest-flow-types
// perhaps we should only keep values here and leave the types in packages
export type BoardPrivacyType = 'secret' | 'public' | 'protected';

/**
 * @enum {string}
 */
const BoardType = {
  PROTECTED: 'protected',
};

/**
 * @enum {string}
 */
const BulkAction = {
  MOVE: 'bulkMove',
  COPY: 'bulkCopy',
  DELETE: 'bulkDelete',
};
export type BulkActionType = $Values<typeof BulkAction>;

/**
 * @enum {string}
 */
const FeedbackType = {
  UNFOLLOW_INTEREST: 'unfollowInterest',
  UNFOLLOW_BOARD: 'unfollowBoard',
  UNFOLLOW_PINNER: 'unfollowPinner',
  HIDE: 'hidePin',
  REPORT: 'reportPin',
  DOWNVOTE: 'downvote',
  DOWNVOTE_INTEREST: 'downvoteInterest',
  DOWNVOTE_BOARD: 'downvoteBoard',
  DOWNVOTE_PIN: 'downvotePin',
  DISABLE_PFY: 'disablePFY',
};

/**
 * From https://github.com/jquery/jquery-ui/blob/master/ui/jquery.ui.core.js
 * @const
 * @type {Object.<string, number>}
 */
const KeyCode = {
  BACKSPACE: 8,
  COMMA: 188,
  DELETE: 46,
  DOWN: 40,
  END: 35,
  ENTER: 13,
  ESCAPE: 27,
  HOME: 36,
  LEFT: 37,
  NUMPAD_ADD: 107,
  NUMPAD_DECIMAL: 110,
  NUMPAD_DIVIDE: 111,
  NUMPAD_ENTER: 108,
  NUMPAD_MULTIPLY: 106,
  NUMPAD_SUBTRACT: 109,
  PAGE_DOWN: 34,
  PAGE_UP: 33,
  PERIOD: 190,
  RIGHT: 39,
  SPACE: 32,
  TAB: 9,
  UP: 38,
};

/**
 * This file stores the constants that we use across all our javascript files
 */

CONST.SCROLL_TO_ELEMENT_OFFSET = 130;
CONST.SCROLL_TO_TOP_ANIMATION_TIME = 300;

CONST.MAX_STORED_VISITED_PAGES = 100;
CONST.MAX_STORED_VISITED_PIN_PAGES = 10;

// response codes
CONST.RESPONSE_CODE_TOO_MANY_REQUESTS = 429;

// form max validators
CONST.MAX_CHARS_FOR_BOARD_TITLE = 180;
CONST.MAX_CHARS_FOR_USER_DESCRIPTION = 160;
CONST.MAX_CHARS_FOR_BOARD_PIN_DESCRIPTION = 500;
CONST.MAX_CHARS_FOR_PIN_TITLE = 100;
CONST.MAX_CHARS_FOR_PIN_DESCRIPTION = 500;

// Acceptable image sizes.
CONST.MIN_PINNABLE_IMAGE_HEIGHT = 50;
CONST.MIN_PINNABLE_IMAGE_WIDTH = 100;

// Max number of followers or collaborators to return per 'page'
CONST.MAX_FETCH_NUM_FOLLOWERS_PER_PAGE = 50;
CONST.MAX_FETCH_NUM_COLLABORATORS_PER_PAGE = 50;

CONST.BoardPrivacy = BoardPrivacy;
CONST.BoardType = BoardType;
CONST.BrowserType = BrowserType;
CONST.BulkAction = BulkAction;
CONST.ErrorStrategy = ErrorStrategy;
CONST.FeedbackType = FeedbackType;
CONST.KeyCode = KeyCode;
CONST.PositionMode = PositionMode;
CONST.ViewActions = ViewActions;

CONST.TYPEAHEAD_ATTRIBUTE_EMPTY_STATE = 'results_empty';

CONST.SCROLL_THROTTLE_DELAY_DEFAULT = 14;

// pin.it domain
CONST.PIN_IT_DOMAIN = 'http://pin.it';

CONST.DEFAULT_PAGE_SIZE = 25;

// API errors
CONST.API_SERVER_ERROR = 12;
CONST.API_SERVER_SPAM_CONTENT = 14;
CONST.API_REQUEST_TIMEOUT = 16;
CONST.API_ERROR_PIN_NOT_FOUND = 50;
CONST.INVALID_PASSWORD_GOOGLE_USER = 76;
CONST.INVALID_PASSWORD_FB_USER = 77;
CONST.INVALID_PASSWORD_ERROR_CODE = 78;
CONST.INVALID_EMAIL_ERROR_CODE = 79;
CONST.INVALID_EMAIL_OR_PASSWORD = 80;
CONST.POLICY_VIOLATION_USER = 83;
CONST.AUTO_PASSWORD_RESET_ERROR_CODE = 85;
CONST.API_ERROR_UNDERAGE_REGISTER_ATTEMPT = 93;

CONST.API_LIMIT_EXCEEDED_ERROR = 8;
CONST.API_EVENT_BLOCKED_ERROR = 9;
CONST.USER_IN_SAFE_MODE = 19;
CONST.LOGIN_VOLUNTARILY_DEACTIVATED_USER = 84;
CONST.LOGIN_BAD_PASSWORD_ASK_RESET = 85;
CONST.LOGIN_MFA_REQUIRED = 1201;
CONST.LOGIN_USER_NOT_FOUND = 30;
CONST.LOGIN_HARD_BANNED_USER = 88;
CONST.FACEBOOK_ACCOUNT_NOT_LINKED = 105;
CONST.SIGNUP_INVALID_EMAIL = 95;

// GDPR parent email consent API errors
CONST.SAME_DEVICE_ID_ERROR = 2341;
CONST.VERIFICATION_CODE_ERROR = 2342;

/**
 * Position point.
 *
 * A position describes a point on an element in a defined orientation.
 * We have two orientations: vertical (top, bottom) and horizontal (left,
 * and right.)
 *
 * Each orientation has different points. For example in the horizontal
 * orientation, you can select a point on the left or on the right of an
 * element, then add more specificity: if you want the top, bottom or
 * middle of the side you've choosen.
 *
 * Each point is a combination of two unique flags: a flag that describes
 * the orientation and a flag that defines the position. For example:
 * TOP_LEFT will be an addition of the VERTICAL_TOP flag and the
 * VERTICAL_LEFT flag:
 *
 *    TOP_LEFT: FLAG_VERTICAL_TOP | FLAG_VERTICAL_LEFT;
 *    In bits: TOP_LEFT = 0001 | 0010 = 0011
 *
 * This approach allows to do quick tests. For example, you want to know
 * if a position is vertical, you just have to test against the
 * FLAG_VERTICAL:
 *
 *    position & FLAG_VERTICAL
 *
 * Another example: if you want to know if a point is HORIZONTAL_CENTER,
 * you can do it without checking if it's either on the left or on the
 * right:
 *
 *    position & FLAG_HORIZONTAL_CENTER.
 */
const flag = parseInt('0000000000001', 2);
let flagCursor = 0;
let currentFlag;
let currentOrientation;

// Generate all the flags.
CONST.PositionPointFlag = CONST.PositionPointFlag || {};
['VERTICAL', 'HORIZONTAL'].forEach((orientation) => {
  currentOrientation = 0;
  ['BOTTOM', 'LEFT', 'CENTER', 'RIGHT', 'TOP'].forEach((point) => {
    currentFlag = flag << flagCursor;
    flagCursor += 1;
    currentOrientation |= currentFlag;
    CONST.PositionPointFlag['FLAG_' + orientation + '_' + point] = currentFlag;
  });
  CONST.PositionPointFlag['FLAG_' + orientation] = currentOrientation;
});
const pointFlag = CONST.PositionPointFlag;

/**
 * All the position points available.
 *
 * @enum {number}
 */
CONST.PositionPoint = {
  CENTER_CENTER: pointFlag.FLAG_VERTICAL_CENTER | pointFlag.FLAG_HORIZONTAL_CENTER,

  BOTTOM_CENTER: pointFlag.FLAG_VERTICAL_BOTTOM | pointFlag.FLAG_VERTICAL_CENTER,
  BOTTOM_LEFT: pointFlag.FLAG_VERTICAL_BOTTOM | pointFlag.FLAG_VERTICAL_LEFT,
  BOTTOM_RIGHT: pointFlag.FLAG_VERTICAL_BOTTOM | pointFlag.FLAG_VERTICAL_RIGHT,

  TOP_CENTER: pointFlag.FLAG_VERTICAL_TOP | pointFlag.FLAG_VERTICAL_CENTER,
  TOP_LEFT: pointFlag.FLAG_VERTICAL_TOP | pointFlag.FLAG_VERTICAL_LEFT,
  TOP_RIGHT: pointFlag.FLAG_VERTICAL_TOP | pointFlag.FLAG_VERTICAL_RIGHT,

  LEFT_BOTTOM: pointFlag.FLAG_HORIZONTAL_LEFT | pointFlag.FLAG_HORIZONTAL_BOTTOM,
  LEFT_CENTER: pointFlag.FLAG_HORIZONTAL_LEFT | pointFlag.FLAG_HORIZONTAL_CENTER,
  LEFT_TOP: pointFlag.FLAG_HORIZONTAL_LEFT | pointFlag.FLAG_HORIZONTAL_TOP,

  RIGHT_BOTTOM: pointFlag.FLAG_HORIZONTAL_RIGHT | pointFlag.FLAG_HORIZONTAL_BOTTOM,
  RIGHT_CENTER: pointFlag.FLAG_HORIZONTAL_RIGHT | pointFlag.FLAG_HORIZONTAL_CENTER,
  RIGHT_TOP: pointFlag.FLAG_HORIZONTAL_RIGHT | pointFlag.FLAG_HORIZONTAL_TOP,
};

/**
 * The Guided Search feature is currently English-only.
 *
 * TODO(yuliang): Support i18n for this feature.
 * TODO(chris): For this list of words, either fetch it from the API, or share it via
 * Thrift constants so that we won't get out of sync with mobile clients.
 */
CONST.SEARCH_FILTER_CONJUNCTIONS = [
  'and',
  'that',
  'but',
  'or',
  'as',
  'if',
  'when',
  'than',
  'because',
  'while',
  'where',
  'after',
  'so',
  'though',
  'since',
  'until',
  'whether',
  'before',
  'although',
  'nor',
  'like',
  'once',
  'unless',
  'now',
  'except',
  'the',
  'a',
  'an',
  'san',
  'for',
  'in',
  'with',
];

/**
 * Repin share upsell experiment
 *
 * For the treatment type, we are hard coding '1' to represent the
 * 'aggressive' treatment group. While web does not have other options
 * for the treatment group, we are adding this field for conformity
 * across platforms.
 *
 * The experience id is needed for testing.
 */
CONST.REPIN_SHARE_UPSELL = {
  TREATMENT_TYPE: { AGGRESSIVE: '1' },
  TEST_ONLY: { EXPERIENCE_ID: '1' },
};

CONST.DEFAULT_IMAGELESS_PIN_COLOR = '#8fa7bf';

CONST.SHOWCASE_TYPE_ARTICLE = 'explorearticle';
CONST.SHOWCASE_TYPE_BOARD = 'board';
CONST.SHOWCASE_TYPE_SHOP = 'shop_recommendation_collection';

CONST.COUNTRY_TO_SUBDOMAIN = {
  AU: 'au.pinterest.com',
  BR: 'br.pinterest.com',
  CZ: 'cz.pinterest.com',
  DK: 'dk.pinterest.com',
  DE: 'de.pinterest.com',
  ES: 'es.pinterest.com',
  MX: 'es.pinterest.com',
  AR: 'es.pinterest.com',
  CO: 'es.pinterest.com',
  CL: 'es.pinterest.com',
  FI: 'fi.pinterest.com',
  FR: 'fr.pinterest.com',
  GB: 'uk.pinterest.com',
  GR: 'gr.pinterest.com',
  HU: 'hu.pinterest.com',
  ID: 'id.pinterest.com',
  IN: 'in.pinterest.com',
  IT: 'it.pinterest.com',
  JP: 'jp.pinterest.com',
  KR: 'kr.pinterest.com',
  NL: 'nl.pinterest.com',
  NO: 'no.pinterest.com',
  NZ: 'nz.pinterest.com',
  PL: 'pl.pinterest.com',
  PT: 'pt.pinterest.com',
  RO: 'ro.pinterest.com',
  RU: 'ru.pinterest.com',
  SK: 'sk.pinterest.com',
  SE: 'se.pinterest.com',
  TR: 'tr.pinterest.com',
  ZA: 'za.pinterest.com',
};

CONST.VIDEO_IFRAME_ID = 'video-iframe';

CONST.AMP_TRACKING_DOMAIN = 'amp.pinterest.com';

CONST.PHONE_NUMBER_SIGNUP_EMAIL_SUBDOMAIN = '@phone.pinterest.com';

// Constants for web account switcher
CONST.MULTIPLE_ACCOUNTS = 'MULTIPLE_ACCOUNTS';
CONST.MULTIPLE_ACCOUNTS_GROUP = 'MULTIPLE_ACCOUNTS_GROUP';

export default CONST;
